module.exports = __webpack_public_path__ + "static/media/14.5470da00.jpg";